var _path, _path2, _path3, _rect;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCalendarEndIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "twotone-closed_caption-24px",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6030",
    "data-name": "Caminho 6030",
    d: "M0,0H24V24H0Z",
    fill: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6031",
    "data-name": "Caminho 6031",
    d: "M5,5H19V7H5Z",
    fill: "rgba(46,128,195,0.3)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6032",
    "data-name": "Caminho 6032",
    d: "M19,3H18V1H16V3H8V1H6V3H5A2.006,2.006,0,0,0,3,5V19a2.006,2.006,0,0,0,2,2H19a2.006,2.006,0,0,0,2-2V5A2.006,2.006,0,0,0,19,3Zm0,16H5V9H19ZM19,7H5V5H19Z",
    fill: "#2e80c3"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_645",
    "data-name": "Ret\\xE2ngulo 645",
    width: 3,
    height: 3,
    transform: "translate(14 14)",
    fill: "#2e80c3"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarEndIcon);
export default __webpack_public_path__ + "static/media/calendar-end-icon.32d7f095510f7b00f4394eef9761a68f.svg";
export { ForwardRef as ReactComponent };